import { Hook, makeHook } from '../hooks/Hook'
import { createRoot, Root } from 'react-dom/client'
import { WebRecorder2State } from '~/webRecorder2/webRecorder2'
import { WebRecorder2Action } from '~/webRecorder2/webRecorder2'
import { WebRecorder2SideEffect } from '~/webRecorder2/webRecorder2'
import { getSingletonMVUReducer } from '~/mvuReducer'
import * as PubSub from '~/webRecorder2/pubSub'
import * as RecordingStorage from '~/webRecorder2/recordingStorage'

export const ConfirmDeleteMeetingHook = makeHook(
  class ConfirmDeleteMeetingHook extends Hook {
    root?: Root

    mounted() {
      /* eslint-disable-next-line no-console */
      console.log(`Mounted ${this.el.id}`)
      this.root = createRoot(this.el)
      this.render(this.root)
      const self = this

      PubSub.subscribe('recording-started', () => {
        self.root && self.render(self.root)
      })
    }

    updated() {
      if (this.root) {
        // If the attributes on the phx-update="ignore" element change,
        // the hook will be re-rendered, so we can use its attributes
        // directly within React.
        this.render(this.root)
      }
    }

    render(_root: Root) {
      if (!this.el.dataset.subjectId) return

      const [state, dispatch] = getSingletonMVUReducer<WebRecorder2State, WebRecorder2Action, WebRecorder2SideEffect>(
        'webRecorder2'
      )

      const isCurrentSubject = state && 'storage' in state && state.storage.subjectId === this.el.dataset.subjectId
      const currentlyRecording = isCurrentSubject && state.mode !== 'initialized'

      const titleElement = document.getElementById(`pc-modal__header__text-${this.el.id}`)

      if (titleElement) {
        titleElement.textContent = currentlyRecording ? 'End meeting capture and delete meeting?' : 'Delete meeting?'
      }

      const displayWhenRecording = this.el.querySelectorAll(`[data-display="when-currently-recording"]`)
      const displayWhenNotRecording = this.el.querySelectorAll(`[data-display="when-not-recording"]`)

      if (currentlyRecording) {
        show(displayWhenRecording)
        hide(displayWhenNotRecording)
      } else {
        show(displayWhenNotRecording)
        hide(displayWhenRecording)
      }

      const form = this.el.querySelector('form')
      const input = form?.querySelector('input[name="confirmation_text"]')
      const subjectId = this.el.dataset.subjectId

      if (form && input) {
        form.addEventListener('submit', async () => {
          if (input && 'value' in input && input.value === 'DELETE') {
            dispatch?.({ action: 'delete-recording', subjectId })

            const storage = await RecordingStorage.openExistingStorage(subjectId, 'confirm-delete-meeting')

            if (storage) {
              await RecordingStorage.clear(storage)
            }
          }
        })
      }
    }

    destroyed() {
      if (this.root) {
        /* eslint-disable-next-line no-console */
        console.log(`Unmounting ${this.el.id}`)
        this.root.unmount()
      }
    }
  }
)

function hide(elements: NodeListOf<Element>) {
  elements.forEach((element) => {
    element.classList.add('hidden')
  })
}

function show(elements: NodeListOf<Element>) {
  elements.forEach((element) => {
    element.classList.remove('hidden')
  })
}
